import { Injectable, Inject } from '@angular/core';
import { IConfig } from './model/config.interface';
import { HttpClient } from '@angular/common/http';
import { UserMessagesService } from './user-messages/user-messages.service';
import { DOCUMENT } from '@angular/common';



@Injectable({
  providedIn: 'root'
})
export class ConfigService
{
    private _config: IConfig;

    constructor(
        private _userMessagesService: UserMessagesService, 
        private _http: HttpClient,
        @Inject(DOCUMENT) private _doc
    )
    {
    }


    injectGoogleAnalyticsKey(): void
    {
        // If the key doesn't exists, the application will be loaded anyway.
        let key: string = this._config.googleAnalyticsKey;
        if(key)
        {
           let elementSrc: HTMLElement = this._doc.getElementById('analytics-source');
           let src: string = elementSrc.getAttribute("src");
           src = src.concat(key);
           elementSrc.setAttribute("src", src);

           let elementCode: HTMLElement = this._doc.getElementById("analytics-jscode");           
           let code: string = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${key}');
           `;
           elementCode.appendChild(this._doc.createTextNode(code));
        }
    }


    // Load config.json file
    // Should be used only in app module while initializing the app
    public loadConfigJSON(): Promise<IConfig>
    {
        if(!this._config)
        {
           return new Promise((resolve, reject) =>
           {
               this._http.get<IConfig>("assets/config/config.json").subscribe(
               (res: IConfig) => {
                   this._config = res;
                   resolve(null);
                }, 
                error => {
                    reject(null); // This will stop the app initialization. Use resolve() only if a message will be shown to the user (otherwise the app will be loaded but without the config, which is mandatory for the app). 
                })
           });           
        }
    }
    
    /*
    // Get config
    public getConfig(): IConfig
    {
        return this._config;
    }
    */

    // Get config property by a specific key
    public getConfigPropertyByKey(key: string): any
    {
        let result: any;
        if(this._config)
        {
            result =  this._config[key];
        }
        return result;
    }
}
